import axios from 'axios'

const instance = axios.create({
  baseURL: import.meta.env.VITE_PD_API_GATEWAY,
})

export default instance
